<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<template>
  <v-container>
    <brandbar></brandbar>
    <v-container id="gym_waiver" class="mt-13">
      <!-- header -->
      <div class="header d-flex flex-column align-center">
        <p class="mb-0">RENO POLICE DEPARTMENT</p>
        <p class="mb-0">EXECUTIVE DIRECTIVE</p>
      </div>
      <div class="sub-header d-flex flex-column align-center">
        <p class="mb-0">Issuing Assistant Chief: Oliver Miller</p>
        <p class="mb-0">Issued Date: March 16, 2022</p>
        <p class="mb-0">Date of Revision: 4/1/2025</p>
        <p class="mb-3">0.00. Title: Gym Facility Use</p>
      </div>
      <hr />

      <v-row class="mt-3">
        <v-col>
          <p>
            The Reno Police Department recognizes that an employee’s physical
            fitness level ensures the development and maintenance of physical
            performance capability and maintaining a lifelong healthy status.
            This overall fitness is achieved through the development of healthy
            lifestyle habits that incorporate a balanced approach to physical
            fitness, supported by the agency and enhanced by the Reno Police
            Department’s Wellness Program. Good physical fitness will not only
            improve readiness, but will also have a positive impact on community
            interactions.<br />
            The Reno Police Department is committed to the health and safety of
            our employees, and has established this directive to provide
            guidance and structure for the use of the gym facilities at the
            police station.
          </p>
        </v-col>
      </v-row>
      <!-- definitions -->
      <v-row class="d-flex flex-column justify-start mt-0">
        <v-col>
          <p class="header"><u>I. DEFINITIONS</u></p>
        </v-col>
        <v-col class="py-0">
          <p class="sub-header py-0">
            <strong>Gym Facility</strong> – Designated area within the Reno
            Police Department where health and fitness equipment are located and
            used by personnel. On or off duty use of the Gym Facility is solely
            restricted to RPD personnel.
          </p>
        </v-col>
      </v-row>

      <!-- PROCEDURES -->
      <v-row class="d-flex flex-column justify-start mt-0 mb-4">
        <v-col>
          <p class="header"><u>II. PROCEDURES</u></p>
        </v-col>
        <v-col class="py-0">
          <ol class="sub-header py-0" type="A">
            <li>On duty use of the Gym Facility by uniformed personnel:</li>
            <ol>
              <li>
                Use of the Gym Facility can be denied at any time by a
                supervisor or watch commander.
              </li>
              <li>
                Prior to use, personnel will confirm if any other uniformed
                personnel are using the Gym Facility to ensure that no more than
                four uniformed personnel are working out at the same time.
              </li>
              <li>
                No more than four uniformed personnel and/or no more than two
                personnel from the same team may use the gym at any given time
                while on duty, at immediate supervisor’s discretion.
              </li>
              <li>
                Uniformed personnel will update dispatch of their status before
                using the Gym Facility by using the ten-code designation,
                “Code-6”.
              </li>
              <li>
                Uniformed personnel will use their lunch and/or break periods as
                designated by applicable collective bargaining agreement while
                working out on duty. (Signal C- 15min., Code 7 – 30 min.,
                Extended Code 7 – 45 min)
              </li>
              <li>
                Uniformed personnel will be available by radio in the event they
                are needed to return to duty.
              </li>
              <li>
                If uniformed personnel decide to shower after use of the gym, it
                must be part of their breaks as designated by collective
                bargaining agreement (Signal C- 15 min., Code 7–30 min.,
                Extended Code 7 – 45 min) and not exceed those times. Time spent
                changing clothing will be counted against the total time out of
                service. The employee must still be available by radio during
                this time.
              </li>
              <li>
                On duty workouts pertain to use of the Reno Police Department
                main station gym facilities only.
              </li>
            </ol>
            <li>Off duty use of the Gym Facility:</li>
            <ol>
              <li>
                Employees will clean up their weights, remove weights from the
                machines after use and clean up the equipment and/or area used.
              </li>
              <li>
                Employees will remain professional and wear appropriate workout
                attire during use of the gym.
              </li>
              <li>Use of the gym facility will be solely for RPD personnel.</li>
            </ol>
            <li>Supervisor responsibilities:</li>
            <ol>
              <li>
                Supervisors are responsible for monitoring on duty personnel’s
                use of the GymFacility to ensure employee compliance with this
                directive.
              </li>
              <li>
                Supervisors will report any issues that arise through their
                chain of command.
              </li>
            </ol>
          </ol>
        </v-col>
      </v-row>

      <!-- RESTRICTIONS -->
      <v-row class="d-flex flex-column justify-start mt-0">
        <v-col>
          <p class="header"><u>III. RESTRICTIONS</u></p>
        </v-col>
        <v-col class="py-0">
          <ol class="sub-header py-0" type="1">
            <li>
              Employees wishing to utilize the gym facility will sign the
              attached City of Reno Wellness Program Release, Waiver and
              Assumption of Risk form, which will be placed into the employee’s
              personnel file.
            </li>
            <li>
              On duty workouts will not be authorized at the beginning or end of
              an employee'sshift.
            </li>
          </ol>
        </v-col>
      </v-row>

      <!-- FORM -->
      <gym_form></gym_form>

      <v-row class="d-flex flex-column justify-start mt-0">
        <v-col>
          <p class="sub-header">
            A copy of this record will be placed in the employee's personnel
            file; such placement does not affect the validity of the record.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
    font-weight: 400;
  }

  .sub-header p,
  .sub-header ol {
    font-size: 1em;
    font-weight: 300;
  }

  .full-form,
  #full_form {
    width: 100%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import brandbar from "./brandbar.vue";
import gym_form from "./gym_form.vue";

export default {
  name: "home",
  components: { gym_form, brandbar },
  mixins: [bus_common],

  // DATA - return
  data() {
    return {
      openDialog_newpart_show: false,
      dialogDelete_newpart: false,
      openDialog_newRandA_show: false,
      dialogDelete_newRandA: false,
      dialog: false,
      dialogDelete: false,
      participants_row: {},
      roster_row: {},

      /* report header info */
      formIn: {
        reporting_officer: "",
        case_num: "",
        outside_agency_num: "",
        mission_type: "",
        select_specialty: "",
        deployment: "",
        location: "",
        date: "",
        time: "",
        select_tactic: "",
        select_risk_officers: "",
        select_risk_suspects: "",
        select_risk_victims: "",
        select_risk_citizens: "",
        select_risk_shots: "",
        select_risk_cbox: "",
        select_associated_docs: "",
        select_assignment: "",
        part_name: "",
        part_assignment: "",

        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",
      },

      lst_training_logs_col: [
        { text: "Officer", align: "center", sortable: true, value: "name" },
        { text: "Date", align: "center", sortable: true, value: "date" },
        { text: "Case#", align: "center", sortable: true, value: "casenum" },
        { text: "Time", align: "center", sortable: true, value: "time" },
      ],

      lst_training_logs: [
        {
          name: "Smith",
          date: "01/01/2024",
          casenum: "24-00023",
          time: "13:00",
        },
        {
          name: "Jones",
          date: "01/01/2024",
          casenum: "24-00024",
          time: "09:00",
        },
        {
          name: "Barnes",
          date: "01/01/2024",
          casenum: "24-00025",
          time: "23:00",
        },
      ],

      specialty: [
        "Explosive Breaching AARs",
        "Sniper AARs",
        "Ropes AArmRs",
        "Team training AARs",
        "Mission AARs",
      ],

      /* tactics and training */

      tactics: [
        "Slow Search",
        "Dynamic Clearing",
        "Stealth to Contact",
        "Area Search",
        "Surround & Call-out",
        "Chemical Agent Deployed",
        "Breach: Manual",
        "Breach: S/G",
        "Breach: Explosive",
        "Noise/Flash Deployed",
        "Rake & Break",
        "Less Lethal",
        "High Rish Surveillence",
        "QRF",
      ],
      /* Risk Mamagement */

      risk_officers: ["Killed", "Injured"],

      risk_suspects: ["Killed", "Injured"],

      risk_victims: ["Killed", "Injured"],

      risk_citizens: ["Killed", "Injured"],

      risk_shots: ["Officers", "Suspects"],

      risk_combobox: [
        "Use of Force",
        "Property Damaged",
        "Vehicle Intervention",
      ],

      /* associated documentation */
      docs: [
        "Threat Matrix Completed",
        "Risk Management Completed",
        "Photos/Videos Taken",
        "CDS Paperwork Completed",
        "Explosive Breach Documents",
        "Blue Team Completed",
      ],

      /* coordinating and participating agencies */
      part_headers: [
        {
          text: "Name - Agency/Division/Unit",
          align: "start",
          sortable: true,
          value: "part_name",
        },
        { text: "Assignment", value: "part_assignment" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      participants: [],
      editedIndex: -1,

      //  Edit Items

      // new particpants
      editedIndex_newpart: -1,
      addpart: {
        part_name: "",
        part_assignment: "",
      },
      defaultItem_newpart: {
        part_name: "",
        part_assignment: "",
      },

      part_participants: [
        "SPD",
        "WCSO",
        "Airport PD",
        "School PD",
        "Lyon County SO",
        "Carson City SO",
        "Douglas County SO",
        "Secret Service",
        "CINT",
      ],

      part_assignments: ["SWAT", "SRT", "K-9", "Patrol", "Detective"],

      //ROSTER AND ASSIGNMENTS

      roster_headers: [
        { text: "Name", align: "start", sortable: false, value: "name" },
        { text: "Present", value: "present" },
        { text: "Assignment", value: "assignment" },
        { text: "Team", value: "team" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      roster_log: [],

      //edited/default Items
      editedItem_newRandA: {
        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",
      },
      defaultItem_newRandA: {
        roster_name: "",
        roster_present: "",
        roster_assignment: "",
        roster_team: "",
      },

      // roster names
      roster_names: [
        "Autry",
        "Baehr",
        "Butler",
        "Chang",
        "Christensen, B",
        "Clifford",
        "Donigan",
        "Dougherty",
        "Duralde",
        "Espinoza, A",
        "Hakin",
        "Hanna",
        "Hendrix",
        "Hogan",
        "Hoyt",
        "Kent",
        "Kerfoot",
        "Lancaster",
        "Lopey",
        "Mathiowetz",
        "Meseberg",
        "Perham, J",
        "Robles",
        "Rousseau",
        "Schaur",
        "Schmidt",
        "Smith",
        "Sotelo",
        "Struffert",
        "Tom",
        "Tone",
        "Waasdorp",
        "Williams",
        "Ziese",
      ],
      roster_ispresent: ["Yes", "No"],
      roster_assignments: ["TAC1", "TAC2", "TAC3", "ODC", "C2", "Sick"],
      roster_teams: [
        "RED CELL",
        "GREEN CELL",
        "BLUE CELL",
        "REMSA TEMS",
        "NONE",
      ],

      // Rules
      situationrules: [
        (v) =>
          (v && v.length <= 4000) ||
          "Description must be less than 4000 characters",
      ],

      missionrules: [
        (v) =>
          (v && v.length <= 8000) ||
          "Description must be less than 8000 characters",
      ],

      notesrules: [
        (v) =>
          (v && v.length <= 8000) ||
          "Description must be less than 8000 characters",
      ],

      expendedrules: [
        (v) =>
          (v && v.length <= 4000) ||
          "Description must be less than 4000 characters",
      ],
    };
  },

  //COMPUTED
  computed: {
    formTitle_newpart() {
      return this.editedIndex_newpart === -1
        ? "New Participant/Assignment"
        : "Edit Participant/Assignment";
    },

    formTitle_addroster() {
      return this.editedIndex_addroster === -1
        ? "New Roster Name"
        : "Edit Roster Name";
    },
  },
  // WATCH
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  //METHODS

  methods: {
    message1() {
      alert("This button will submit the form");
    },
    message2() {
      alert("This button will cancel the form");
    },

    openDialog_newpart() {
      this.openDialog_newpart_show = true;
      console.log("openDialog_newpart");
      this.addpart = this.mno(this.defaultItem_newpart);
    },
    editItem_newpart(item) {
      this.editItem_newpart = this.mno(item);
      this.openDialog_newpart_show = true;
    },

    deleteItem_newpart(index) {
      this.items_newpart.splice(index, 1);
    },
    newpartCloseDialog() {
      this.openDialog_newpart_show = false;
      this.$nextTick(() => {
        this.addpart = this.mno(this.defaultItem_newpart);
        this.editedIndex_newpart = -1;
      });
    },

    // newRandA
    openDialog_newRandA() {
      this.openDialog_newRandA_show = true;
      console.log("openDialog_newRandA");
      this.addpart = this.mno(this.defaultItem_newRandA);
    },
    editItem_newRandA(item) {
      this.editItem_newRandA = this.mno(item);
      this.openDialog_newRandA_show = true;
    },

    deleteItem_newRandA(index) {
      this.items_newRandA.splice(index, 1);
    },
    newRandACloseDialog() {
      this.openDialog_newRandA_show = false;
      this.$nextTick(() => {
        this.addpart = this.mno(this.defaultItem_newRandA);
        this.editedIndex_newRandA = -1;
      });
    },

    editItem(item) {
      this.editedIndex = this.participants.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.participants.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.participants.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    saveItem_newpart() {
      this.participants.push(this.addpart);
      // this.close();
      this.openDialog_newpart_show = false;
    },

    saveItem_roster() {
      console.log(this.editedItem_roster.name);
      if (this.editedIndex_roster > -1) {
        this.items_roster[this.editedIndex_roster] = this.mno(
          this.editedItem_roster
        );
      } else {
        this.items_roster.push(this.editedItem_roster);
      }
      this.rosterCloseDialog();
    },

    // INIT
    init() {
      this.participants = [
        {
          part_name: "SPD",
          part_assignment: "K9",
        },
        {
          part_name: "WCSO",
          part_assignment: "Patrol",
        },
      ];

      this.roster_log = [
        {
          name: "Autry",
          present: "Yes",
          assignment: "C2",
          team: "none",
        },
        {
          name: "Robles",
          present: "No",
          assignment: "ODC",
          team: "none",
        },
      ];
    },
  },

  // mounted
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
